/* eslint-disable prettier/prettier */
import type { State } from "./state";
import type { ProductListStore } from './types';

const removeFromList = (list: any[] | undefined, id: string | number) => {
  list?.splice(list.indexOf(id), 1);
}

const mutations = {
  SET_EXPAND_LIST: (state: State, params: { id: any; filter: any; }) => {
    const {id, filter} = params;
    const expandedList = (state.product[filter as keyof typeof state.product] as ProductListStore).expandedList;
    const isExpanded = expandedList?.includes(id);
    if (isExpanded) {
      return removeFromList(expandedList, id);
    }
    expandedList?.push(id);
  },
  SET_SEARCH_BY: (state: State, searchByVal: string) => {
    state.searchBy = searchByVal;
  },
  SET_FETCHED_ALL: (state: State, type: string) => {
    (state.product[type as keyof typeof state.product] as ProductListStore).fetched = true;
  },
  SET_FETCHED_ALL_QUERY: (state: State, type: string) => {
    (state.product[type as keyof typeof state.product] as ProductListStore).queryFetched = true;
  },
  SET_ASSIGNED_PRODUCT: (state: State, productId: string) => {
    const { assigned, selected } = state.product.assignment;
    const isNotAssigned = !assigned.has(productId);
    const isNotSelected = !selected.has(productId);
    if (isNotAssigned) assigned.add(productId);
    if (isNotSelected) selected.add(productId);
  },
  UPDATE_ASSIGNED_PRODUCT: (state: State, productId: string) => {
    const { assigned, selected, unselected } = state.product.assignment;
    const isAssigned = assigned.has(productId);
    const isSelected = selected.has(productId);
    
    if (isSelected) {
      if (isAssigned) unselected.add(productId);
      return selected.delete(productId);
    }
    
    if (isAssigned) {
      unselected.delete(productId);
    }
    
    selected.add(productId);
  },
  SET_SELECT_ALL: (state: State, productList: any[]) => {
    const { assigned, selected, unselected } = state.product.assignment;
    const listId = productList.map((product: { id: number }) => product.id);
    const isNotSelectAll = !listId.every(id => selected.has(id));

    const length = listId.length;
    for (let i = 0; i < length; i++) {
      const id = listId[i];
      const isSelected = selected.has(id);
      const isAssigned = assigned.has(id);

      if (isSelected) {
        if (isNotSelectAll) return;
        if (isAssigned) unselected.add(id);
        selected.delete(id);
        continue;
      }

      if (isAssigned) {
        unselected.delete(id);
      }

      selected.add(id);
    }
  },
  RESET_SEARCH_RESULT: (state: State) => {
    state.product.all.queryList = [];
    state.product.all.queryFetched = false;
    state.product.all.endCursorQuery = '';
    
    state.product.pages.queryList = [];
    state.product.pages.products = [];
    state.product.pages.queryFetched = false;
    state.product.pages.endCursorQuery = '';
    state.product.pages.expandedList = [];
    
    state.product.collections.queryList = [];
    state.product.collections.products = [];
    state.product.collections.queryFetched = false;
    state.product.collections.endCursorQuery = '';
    state.product.collections.expandedList = [];
  },
  RESET_SELECT_PRODUCT: (state: State) => {
    state.product.assignment.selected = new Set();
    state.product.assignment.unselected = new Set();
  },
  RESET_SELECT_BY_FILTER: (state: State, selectedByFilter: any[]) => {
    const toRemove = new Set(selectedByFilter);
    state.product.assignment.selected = new Set([...state.product.assignment.selected].filter(
      id => !toRemove.has(id)
    ));
  },
  RESET_PRODUCT_DATA: (state: State) => {
    return state.resetProductData();
  },
  REFRESH_PRODUCT_DATA: (state: State) => {

    state.assignedOnly = true;
    state.assignedOnlyQuery = true;

    state.product.all.list = [];
    state.product.all.products = [];
    state.product.all.fetched = false;
    state.product.all.endCursor = '';
    
    state.product.pages.list = [];
    state.product.pages.products = [];
    state.product.pages.fetched = false;
    state.product.pages.endCursor = '';
    state.product.pages.expandedList = [];
    
    state.product.collections.list = [];
    state.product.collections.products = [];
    state.product.collections.fetched = false;
    state.product.collections.endCursor = '';
    state.product.collections.expandedList = [];

    state.product.assignment.assigned = new Set();
    state.product.assignment.selected = new Set();
    state.product.assignment.unselected = new Set();
  }
};
export default mutations;
